// extracted by mini-css-extract-plugin
export var measureBox = "_8a-0";